// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {ConfirmationAgency} from './ConfirmationAgency';

const _associations = [
			{
				name: 'ConfirmationAgency',
				model: new ConfirmationAgency(),
				type: 'ArrayOfChildren',
				using: 'confirmationAgencyId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ConfirmationAgency',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'programConfirmationAgencyId',
				placeholder: null,
				key: 'programConfirmationAgencyId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.programConfirmationAgencyId,
				setter: (x, y) => x.programConfirmationAgencyId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'programId',
				placeholder: null,
				key: 'programId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.programId,
				setter: (x, y) => x.programId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Confirmation Agency',
				placeholder: null,
				key: 'confirmationAgencyId',
				isPrimaryKey: false,
				displayLabel: false,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.confirmationAgencyId,
				setter: (x, y) => x.confirmationAgencyId = y,
				defaultValue: null,
				editor: 'ConfirmationAgencyEditor',
				viewer: 'ConfirmationAgencyViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
];

export class ProgramConfirmationAgency extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
